import type { AxisConfig, BoundingBoxConfig, GridConfig, TicksConfig } from './coordinate-system.model';

// =============================================================================
// GRID DEFAULTS
// =============================================================================

export const DEFAULT_GRID_CONFIG: GridConfig = {
  type: 'lines',
  visible: true,
};

// =============================================================================
// TICKS DEFAULTS
// =============================================================================

/** Default ticks config - no ticksDistance to enable JSXGraph auto-resolution */
export const DEFAULT_TICKS_CONFIG: TicksConfig = {
  minorTicks: 0,
  majorHeight: 5,
  minorHeight: 0,
  drawLabels: true,
  drawZero: false,
};

// =============================================================================
// AXIS DEFAULTS
// =============================================================================

export const DEFAULT_AXIS_LABEL_OFFSET_HORIZONTAL: [number, number] = [-10, 15];
export const DEFAULT_AXIS_LABEL_OFFSET_VERTICAL: [number, number] = [15, -10];

// Tick label offsets: [x, y] in pixels from tick position
export const DEFAULT_TICK_LABEL_OFFSET_X_AXIS: [number, number] = [0, -12];
export const DEFAULT_TICK_LABEL_OFFSET_Y_AXIS: [number, number] = [8, 0];
export const DEFAULT_TICK_LABEL_OFFSET_SECONDARY_HORIZONTAL: [number, number] = [0, -15];

// =============================================================================
// COORDINATE SYSTEM DEFAULTS
// =============================================================================

export const DEFAULT_BOUNDING_BOX: BoundingBoxConfig = { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 };

/**
 * Creates default axes (standard x-y coordinate system through origin).
 */
export function createDefaultAxes(): AxisConfig[] {
  return [
    {
      id: 'x',
      orientation: 'horizontal',
      position: 0,
      isPrimary: true,
      drawGridLines: true,
      ticks: { ...DEFAULT_TICKS_CONFIG },
    },
    {
      id: 'y',
      orientation: 'vertical',
      position: 0,
      isPrimary: true,
      drawGridLines: true,
      ticks: { ...DEFAULT_TICKS_CONFIG },
    },
  ];
}
